import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { removeTodo, addTodo, updateTodo } from '../features/todo/todoSLice'
import { motion } from 'framer-motion';
import { useState } from 'react';
function Todo() {
    const [value, setValue] = useState('')
    const [updateText, setUpdateText] = useState('');
    const [updateId, setUpdateId] = useState(false);
    const dispatch = useDispatch();
    const todos = useSelector(state => state.todos)
    console.log(todos)
    const [editing, setEditing] = useState("Add Task")
    function handleSubmit(e) {
        e.preventDefault();
        if (editing === 'Add Task') {
            dispatch(addTodo(value));
        } else if (editing === 'Update Task') {
            console.log("value", value)
            console.log("todosarray", todos)
            const taskId = todos.find(todo => todo.description === value)?.id;
            console.log("taskid", taskId)
            if (taskId) {
                dispatch(updateTodo({ id: taskId, description: value }));
                setEditing('Add Task');
            }
            setEditing('Add Task');
        }
        setValue("")

    }
    function removeTodoItem(id) {
        dispatch(removeTodo(id))
    }


    const handleUpdateTodo = () => {
        dispatch(updateTodo({ id: updateId, changes: { description: updateText } }));
        setUpdateId(false);
        setUpdateText('');
    };

    return (
        <>
            <div >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <form onSubmit={handleSubmit} style={{ display: "flex", alignItems: "center" }}>
                        <input style={{ borderRadius: '10px', padding: "15px" }} type='text' placeholder='Enter task' value={value} onChange={e => setValue(e.target.value)} />
                        <button type='submit' style={{ padding: '15px', borderRadius: '30px', marginLeft: '5px', paddingLeft: '10px', paddingRight: "10px", cursor: "pointer", backgroundColor: "blueviolet", color: "white" }}>{editing}</button>
                    </form>
                </div>
            </div>
            <div >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <h1 style={{ alignItems: "center", justifyContent: "center", justifyItems: "center" }}>Crafting Efficiency: Your Tailored To-Do Task List</h1>
                </div>
                <div>
                    {todos.map((item, index) => {
                        return (
                            <div key={item.id} style={{}}>
                                <motion.li
                                    initial={{ opacity: 0, x: -50 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    exit={{ opacity: 0, x: 50 }}
                                    transition={{ duration: 0.5, delay: index * 0.2 }}
                                    style={{ display: 'flex', gap: '5px', backgroundColor: "#b35353", color: "white", marginLeft: "40px", marginRight: "40px", padding: '10px', justifyContent: "space-between", marginBottom: "10px" }} >
                                    <p style={{ marginBottom: '10px' }}>{item.description}</p>
                                    {updateId === item.id ? (
                                        <>
                                            <input
                                                type="text"
                                                style={{ width: "40%" }}
                                                value={updateText}
                                                onChange={e => setUpdateText(e.target.value)}
                                            />
                                            <div style={{ display: "flex", gap: "2rem", alignItems: "center" }}>
                                                <button style={{ borderRadius: "4px", cursor: "pointer", padding: "15px 10px" }} onClick={handleUpdateTodo}>Update</button>
                                                <button style={{ cursor: "pointer", display: "flex", gap: '5px', background: "transparent", border: "none", color: "white", alignItems: "center" }} onClick={() => removeTodoItem(item.id)}>
                                                    <span style={{ fontSize: "20px" }}>✖</span>
                                                </button>
                                            </div>
                                        </>
                                    ) : (
                                        <div style={{ display: "flex", gap: "2rem" }}>
                                            <button style={{ borderRadius: "4px", cursor: "pointer", padding: '10px 20px' }} onClick={() => setUpdateId(item.id)}>Edit</button>
                                            <button style={{ cursor: "pointer", display: "flex", gap: '5px', background: "transparent", border: "none", color: "white", alignItems: "center" }} onClick={() => removeTodoItem(item.id)}>
                                                <span style={{ fontSize: "20px" }}>✖</span>
                                            </button>

                                        </div>
                                    )}
                                </motion.li>
                            </div>
                        )
                    })}
                </div>
            </div>

        </>
    )
}

export default Todo